module.exports = __webpack_public_path__ + "img/poster7-sub1.90e45ee2.png";